<template>
  <auth-page-wrapper :container-class="['store', {active_bonus: bonusPhaseConfiguration.enabled}]">
    <section>
      <h1>{{ $_getTranslations.home_store_title }}</h1>

      <bonus-phase-section
        v-if="bonusPhaseConfiguration.enabled"
        :timer="bonusPhaseConfiguration.timerValue"
        :amount="bonusPhaseConfiguration.amount"
      ></bonus-phase-section>

      <store-list-item
        v-for="storeItem in orderedStoreItems"
        :key="storeItem.bundleId"
        :item="storeItem"
        :bonus-phase-enabled="bonusPhaseConfiguration.enabled"
        :bonus-phase-amount="bonusPhaseConfiguration.amount"
        @select:storeItem="getIt"
      ></store-list-item>

      <invite-friend-list-item
        v-if="inviteConfig.inviteEnable"
        @invite:friend="shareFriendsInvitation"
      ></invite-friend-list-item>

      <vat-section v-if="vatBanner"></vat-section>
    </section>

    <component :is="modalForStore" @bundlePurchase="onBundlePurchase"></component>
  </auth-page-wrapper>
</template>

<script>
/* eslint no-console: "off", no-param-reassign: ["error", { "props": false }], no-use-before-define: ["error", { "variables": false }] */

import {mapGetters, mapActions, mapState, mapMutations} from 'vuex'
import Vue from 'vue'
import BaseLoaderModal from '../../common/modal/BaseLoaderModal'
import AuthPageWrapper from '../../common/wrapper/AuthPageWrapper'
import ResubscribeGame from '../modals/ResubscribeGame'
import ResubscribeGameSms from '../modals/ResubscribeGameSms'
import ConfirmPurchase from '../modals/store/ConfirmPurchase'
import ConfirmPurchaseForPin from '../modals/store/ConfirmPurchaseForPin'
import ConfirmPurchaseForPinError from '../modals/store/ConfirmPurchaseForPinError'
import ConfirmPurchaseViaSms from '../modals/store/ConfirmPurchaseViaSms'
import InviteFriend from '../modals/users/InviteFriend'
import BonusPhaseSection from './section/BonusPhaseSection'
import VatSection from './section/VatSection'
import StoreListItem from './item/StoreListItem'
import InviteFriendListItem from './item/InviteFriendListItem'
import FacebookMixin from '../../../common/mixins/facebookIntegration'
import translationMixin from '../../../common/mixins/translation'
import modals from '../../../common/modals'
import {isAndroidDevice, isiOSDevice} from '../../../helpers/common'
import {apiResponseTypeEnum} from '../../../constants/api'

const moment = require('moment')

Vue.use(require('vue-moment'), {
  moment
})

export default {
  name: 'store',
  components: {
    AuthPageWrapper,
    BonusPhaseSection,
    VatSection,
    StoreListItem,
    InviteFriendListItem,
    InviteFriend
  },
  mixins: [
    FacebookMixin,
    translationMixin
  ],
  watch: {
    phaseBonusList: {
      handler () {
        this.initializeBonusPhase()
      },
      deep: true,
      immediate: true
    }
  },
  data () {
    return {
      bonusPhaseConfiguration: {
        timerValue: '',
        timerIntervalId: null,
        timerIntervalDelay: 1000,
        amount: 0,
        enabled: false
      },
      redirectUrl: ''
    }
  },
  created () {
    this.redirectUrl = `${window.location.href}/${this.getLocale || localStorage.getItem('locale')}/`
    if (this.facebookFunctionality) {
      this.forceFbToScrapNewMetadata(this.redirectUrl, () => {
        // eslint-disable-next-line
        console.log('successful scrapping!')
      })
    }
  },
  mounted () {
    this.storedBundlesCall()
  },
  beforeDestroy () {
    this.setBundles({value: []})
  },
  methods: {
    ...mapActions('profile', [
      'requestPin',
      'storedBundlesCall',
      'getUserLoginDetails'
    ]),
    ...mapMutations('profile', [
      'setBundleId',
      'setBundleData',
      'setBundles'
    ]),
    ...mapMutations('common', [
      'storeModalForStore'
    ]),
    initializeBonusPhase () {
      const initializeBonusPhaseTimer = bonusPhaseEndDatetime => {
        const __bonusPhaseEndDatetime = moment(bonusPhaseEndDatetime)
        let duration = null

        const timerIntervalCallback = () => {
          const currentDatetime = moment(new Date())
          duration = moment.duration(__bonusPhaseEndDatetime.diff(currentDatetime))
          duration = moment.duration(duration - this.bonusPhaseConfiguration.timerIntervalDelay, 'milliseconds')

          if (currentDatetime.isAfter(__bonusPhaseEndDatetime)) {
            if (this.bonusPhaseConfiguration.timerIntervalId) {
              clearInterval(this.bonusPhaseConfiguration.timerIntervalId)
            }

            this.bonusPhaseConfiguration.timerValue = ''
            this.bonusPhaseConfiguration.enabled = false
          } else {
            this.bonusPhaseConfiguration.timerValue = [duration.hours(), duration.minutes(), duration.seconds()]
              .map(value => value < 10 ? `0${value}` : value)
              .join(' : ')
          }
        }

        timerIntervalCallback()
        this.bonusPhaseConfiguration.enabled = !!this.bonusPhaseConfiguration.timerValue

        if (this.bonusPhaseConfiguration.enabled) {
          this.bonusPhaseConfiguration.timerIntervalId = setInterval(timerIntervalCallback, this.bonusPhaseConfiguration.timerIntervalDelay)
        }
      }

      if (this.bonusPhaseConfiguration.enabled ||
        !Array.isArray(this.phaseBonusList) ||
        (this.phaseBonusList.length === 0)
      ) {
        return
      }

      const bonusPhaseBundleDiscount = this.phaseBonusList.find(({type}) => type === 'BUNDLES')

      if (bonusPhaseBundleDiscount) {
        this.bonusPhaseConfiguration.amount = bonusPhaseBundleDiscount.multiplier
        initializeBonusPhaseTimer(bonusPhaseBundleDiscount.end)
      }
    },
    showModal () {
      modals.setupCommonModal({
        afterHideCallback: () => {
          this.storeModalForStore(null)
        }
      })
    },
    onBundlePurchase () {
      this.getUserLoginDetails()
    },
    shareFriendsInvitation () {
      this.storeModalForStore(InviteFriend)
      this.showModal()
    },
    getIt (storeItem) {
      const callbackAfterUserDetailsAction = () => {
        this.storeModalForStore(null)

        if (this.purchaseBundleFromUnsubUser) {
          this.getBundle(storeItem)
        } else {
          // eslint-disable-next-line
          if (!this.userDetails.subscribed) {
            if (this.subAndUnsubViaSMS) {
              if (['REOPTIN_SMS', 'REOPTIN_OPTOUT_SMS'].includes(this.reoptinAndOptoutConfig)) {
                this.storeModalForStore(ResubscribeGameSms)
              } else {
                this.storeModalForStore(ResubscribeGame)
              }
            } else {
              this.storeModalForStore(ResubscribeGame)
            }

            this.showModal()
          } else {
            this.getBundle(storeItem)
          }
        }
      }

      this.storeModalForStore(BaseLoaderModal)
      modals.setupCommonModal({hideManually: true})

      this.getUserLoginDetails().then(() => {
        modals.hideCommonModal({immediate: true, afterHideCallback: callbackAfterUserDetailsAction})
      })
    },
    getBundle ({bundleId, noOfGames, price, currencyCode, points}) {
      this.setBundleId(bundleId)

      this.setBundleData({
        numberOfGames: noOfGames,
        price,
        currencyCode,
        points
      })

      if (this.purchaseViaSMS) {
        if (this.smsAutomaticResponse) {
          const phoneNumber = this.$_translateTextByOperator({key: 'home_store_shortcode'})
          const message = this.$_translateTextByOperator({key: 'home_store_keyword'})

          let smsLink

          if (isAndroidDevice()) {
            smsLink = `sms:${phoneNumber}?body=${message}`
            window.location.href = smsLink
          } else if (isiOSDevice()) {
            smsLink = `sms:${phoneNumber}&body=${message}`
            window.location.href = smsLink
          } else {
            this.storeModalForStore(ConfirmPurchaseViaSms)
            this.showModal()
          }
        } else {
          this.storeModalForStore(ConfirmPurchaseViaSms)
          this.showModal()
        }
      } else {
        // eslint-disable-next-line
        if (this.pinForBundles) {
          const callbackAfterRequestPinAction = () => {
            this.storeModalForStore(null)

            if (this.requestPinResponse === apiResponseTypeEnum.OPERATION_SUCCESS) {
              this.storeModalForStore(ConfirmPurchaseForPin)
              this.showModal()
            } else {
              this.storeModalForStore(ConfirmPurchaseForPinError)
              this.showModal()
            }
          }

          this.storeModalForStore(BaseLoaderModal)
          modals.setupCommonModal({showImmediate: true, hideManually: true})

          const bundleInfo = {bundleId}

          this.requestPin({value: bundleInfo}).then(() => {
            modals.hideCommonModal({immediate: true, afterHideCallback: callbackAfterRequestPinAction})
          })
        } else {
          this.storeModalForStore(ConfirmPurchase)
          this.showModal()
        }
      }
    }
  },
  computed: {
    ...mapState('common', [
      'inviteConfig',
      'smsAutomaticResponse',
      'purchaseBundleFromUnsubUser',
      'facebookFunctionality',
      'subAndUnsubViaSMS',
      'reoptinAndOptoutConfig',
      'pinForBundles',
      'purchaseViaSMS',
      'modalForStore',
      'userDetails',
      'vatBanner'
    ]),
    ...mapState('profile', [
      'storedBundles',
      'requestPinResponse',
      'phaseBonusList'
    ]),
    ...mapGetters('i18n', [
      'getLocale'
    ]),
    orderedStoreItems () {
      return (Array.isArray(this.storedBundles) && [...this.storedBundles].sort((a, b) => a.noOfGames - b.noOfGames)) || []
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/home/store/Store.vue